import { createSelector } from 'reselect';
import { TStateEnv, RootState } from 'stores/reducers';

export const getEnv = ({ env }: RootState): TStateEnv => env;
export const getOrchestratorHost = createSelector(getEnv, ({ ORCHESTRATOR_HOST }) => ORCHESTRATOR_HOST);
export const getConfiguratorURL = createSelector(getEnv, ({ CONFIGURATOR_URL }) => CONFIGURATOR_URL);
export const selectIsHideHeaderAndFooter = createSelector(
  getEnv,
  ({ HIDE_HEADER_AND_FOOTER = false }) => HIDE_HEADER_AND_FOOTER
);
